import { createContext } from 'react';

const recipesContext = createContext();

export default recipesContext;
